import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../Firebase/firebaseConfig";
import { collection, endAt, getDocs, orderBy, query, startAt } from "firebase/firestore";
import { set } from "date-fns";
import { Dispatch, SetStateAction } from "react";

export const uploadImageToFirebase = async (file: File, bucketName?:string) => {
    const storageRef = ref(storage, `${bucketName ? bucketName : 'images'}/${file.name}_${Date.now()}`);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    console.log("Image uploaded successfully", downloadURL);
    return downloadURL;
}


export const searchProductsByName = (
    searchText: string,
    timerRef: any,
    setResults: Dispatch<SetStateAction<any>>
  ) => {
    if (timerRef.current) clearTimeout(timerRef.current);
  
    if (searchText.length < 3) {
      setResults([]);
      return;
    }
  
    timerRef.current = setTimeout(async () => {
      const lowerSearch = searchText.toLowerCase();
      const productsRef = collection(db, "products");
  
      // Query by name
      const nameQuery = query(
        productsRef,
        orderBy("name"),
        startAt(lowerSearch),
        endAt(lowerSearch + "\uf8ff")
      );
  
      // Query by subtitle
      const subtitleQuery = query(
        productsRef,
        orderBy("subtitle"),
        startAt(searchText),
        endAt(searchText + "\uf8ff")
      );
  
      // Run both queries in parallel
      const [nameSnap, subtitleSnap] = await Promise.all([
        getDocs(nameQuery),
        getDocs(subtitleQuery),
      ]);
  
      const nameResults = nameSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const subtitleResults = subtitleSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
  
      // Combine and deduplicate based on ID
      const combined = [...nameResults, ...subtitleResults];
      const uniqueResults = [
        ...Array.from(new Map(combined.map((item) => [item.id, item])).values()),
      ];
 
  
      setResults(uniqueResults);
    }, 500);
  };
